/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ServiceLevelHistoryItemType = {
    Changed: 'CHANGED',
    Accepted: 'ACCEPTED',
    Request: 'REQUEST',
    Declined: 'DECLINED'
} as const;
export type ServiceLevelHistoryItemType = typeof ServiceLevelHistoryItemType[keyof typeof ServiceLevelHistoryItemType];


export function instanceOfServiceLevelHistoryItemType(value: any): boolean {
    for (const key in ServiceLevelHistoryItemType) {
        if (Object.prototype.hasOwnProperty.call(ServiceLevelHistoryItemType, key)) {
            // @ts-ignore
            if (ServiceLevelHistoryItemType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServiceLevelHistoryItemTypeFromJSON(json: any): ServiceLevelHistoryItemType {
    return ServiceLevelHistoryItemTypeFromJSONTyped(json, false);
}

export function ServiceLevelHistoryItemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelHistoryItemType {
    return json as ServiceLevelHistoryItemType;
}

export function ServiceLevelHistoryItemTypeToJSON(value?: ServiceLevelHistoryItemType | null): any {
    return value as any;
}

